var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useAtom, useSetAtom } from 'jotai';
import { useLoaderData } from 'react-router';
import loadable from '@loadable/component';
import { FetchResponseError } from "../../../../../../shared/JSONRequest";

import { Translate } from "../../../../../I18N";

import { Button, Sidepanel, ToggleButton, VerticalDrawer, Truncate } from "../../../../Components/UI";
import { notificationAtom } from "../../../../atoms";
import { secondsToISODate } from "../../../../shared/dateHelpers";

import {
  coerceValue,
  getFormValue,
  handleEntitySave,
  loadSidepanelData,
  SELECT_TYPES } from "../helpers";

import { SidepanelForms } from "./SidepanelForms";
import { highlightsAtom, selectionErrorAtom, textSelectionAtom } from "./atoms";
import { selectAndSearchAtom } from "./atoms/selectAndSearchAtom";

//This is imported via loadable due to https://github.com/huridocs/uwazi/issues/7808
const TextProperty = loadable(async () => (await import("./TextProperty")).TextProperty);









// eslint-disable-next-line max-statements
const PropertySidepanel = ({
  showSidepanel,
  setShowSidepanel,
  suggestion,
  onEntitySave,
  property
}) => {
  const { templates } = useLoaderData();
  const [entity, setEntity] = useState();
  const [highlights, setHighlights] = useAtom(highlightsAtom);
  const [selectionError, setSelectionError] = useAtom(selectionErrorAtom);
  const [selectedText, setSelectedText] = useAtom(textSelectionAtom);
  const [selectAndSearch, setSelectAndSearch] = useAtom(selectAndSearchAtom);
  const setNotifications = useSetAtom(notificationAtom);

  useEffect(() => {
    if (suggestion) {
      loadSidepanelData(suggestion).
      then(({ entity: suggestionEntity }) => {
        setEntity(suggestionEntity);
      }).
      catch((e) => {
        throw e;
      });
    }
  }, [property, suggestion]);

  const templateId = suggestion === null || suggestion === void 0 ? void 0 : suggestion.entityTemplateId;
  const template = templates.find((t) => t._id.toString() === templateId);

  const handleClose = () => {
    setEntity(undefined);
    setShowSidepanel(false);
    setSelectAndSearch(false);
    setSelectedText(undefined);
    setSelectionError(undefined);
  };

  const formContext = useForm({
    values: {
      field: getFormValue(suggestion, entity, property === null || property === void 0 ? void 0 : property.type)
    }
  });

  const { isSubmitting, isDirty } = formContext.formState;
  const { handleSubmit, setValue } = formContext;

  const onSubmit = async (value) =>

  {
    const savedEntity = await handleEntitySave(entity, property, value.field, template, isDirty);

    if (savedEntity instanceof FetchResponseError) {
      const details = savedEntity === null || savedEntity === void 0 ? void 0 : savedEntity.json.prettyMessage;

      setNotifications({ type: 'error', text: 'An error occurred', details });
    } else if (savedEntity) {
      if (savedEntity) {
        setEntity(savedEntity);
        onEntitySave();
      }

      setNotifications({ type: 'success', text: 'Saved successfully.' });
    }

    handleClose();
  };

  const handleClickToFill = async () => {
    if (selectedText) {
      if ((property === null || property === void 0 ? void 0 : property.type) === 'date' || (property === null || property === void 0 ? void 0 : property.type) === 'numeric') {
        const coercedValue = await coerceValue(property.type, selectedText.text, entity === null || entity === void 0 ? void 0 : entity.language);

        if (!(coercedValue !== null && coercedValue !== void 0 && coercedValue.success)) {
          setSelectionError('Value cannot be transformed to the correct type');
        } else {
          const value =
          property.type === 'date' ? secondsToISODate(coercedValue.value) : coercedValue.value;
          setValue('field', value, { shouldDirty: true });
          setSelectionError(undefined);
        }
      } else {var _selectedText$text;
        const sanitizedText = (_selectedText$text = selectedText.text) === null || _selectedText$text === void 0 ? void 0 : _selectedText$text.replace(/[\n\r]/g, ' ');
        setValue('field', sanitizedText, { shouldDirty: true });
      }
    }
  };

  return (/*#__PURE__*/
    _jsx(Sidepanel, {
      isOpen: showSidepanel,
      withOverlay: true,
      size: "large",
      title: /*#__PURE__*/_jsx(Truncate, { maxLength: 80 }, void 0, entity === null || entity === void 0 ? void 0 : entity.title),
      closeSidepanelFunction: handleClose }, void 0, /*#__PURE__*/

    _jsx(Sidepanel.Body, { className: "overflow-y-auto" }, void 0, /*#__PURE__*/
    _jsx(TextProperty, {
      propertyName: suggestion === null || suggestion === void 0 ? void 0 : suggestion.extractorSource.property,
      entity: entity,
      template: template,
      onSelect: (selection) => {
        setSelectedText(selection);
      },
      onDeselect: () => {
        setSelectedText(undefined);
      } }
    )
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, { className: "sticky bg-white border-t border-gray-200 shadow-[0_-6px_12px_-3px_rgba(0,0,0,0.15)]" }, void 0, /*#__PURE__*/

    React.createElement(FormProvider, formContext, /*#__PURE__*/
    _jsx("form", { onSubmit: handleSubmit(onSubmit) }, void 0, /*#__PURE__*/
    _jsx(VerticalDrawer, {
      defaultOpen: true,
      title: /*#__PURE__*/
      _jsx("div", { className: "flex gap-4 items-center" }, void 0, /*#__PURE__*/
      _jsx(Translate, {
        className: `font-semibold uppercase ${selectionError ? 'text-pink-600' : 'text-gray-500'}`,
        context: templateId }, void 0,

      property === null || property === void 0 ? void 0 : property.label
      ),
      SELECT_TYPES.includes((property === null || property === void 0 ? void 0 : property.type) || '') && /*#__PURE__*/
      _jsx(ToggleButton, {
        size: "small",
        onToggle: () => setSelectAndSearch(!selectAndSearch) }, void 0, /*#__PURE__*/

      _jsx(Translate, { className: "font-medium text-xs text-gray-900" }, void 0, "Select & Search"

      )
      ),

      selectionError && /*#__PURE__*/_jsx("span", { className: "text-pink-600" }, void 0, selectionError)
      ) }, void 0, /*#__PURE__*/


    _jsx(SidepanelForms, {
      property: property,
      suggestion: suggestion,
      handleClickToFill: handleClickToFill,
      clearSelectionButton: /*#__PURE__*/
      _jsx("div", { className: "sm:text-right", "data-testid": "ix-clear-button-container" }, void 0, /*#__PURE__*/
      _jsx(Button, {
        type: "button",
        styling: "outline",
        disabled: Boolean(!highlights) || isSubmitting,
        onClick: () => {
          setHighlights(undefined);
        } }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Clear")
      )
      ) }

    )
    ), /*#__PURE__*/
    _jsx("div", { className: "flex justify-end gap-2 px-4 py-2 border-t border-gray-200" }, void 0, /*#__PURE__*/
    _jsx(Button, { type: "button", styling: "outline", disabled: isSubmitting, onClick: handleClose }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, { type: "submit", disabled: isSubmitting, color: "success" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Accept")
    )
    )
    )
    )
    )
    ));

};

export { PropertySidepanel };